import { type FC, type PropsWithChildren } from 'react'
import { Box } from '@dhl-ui/components'

export const StickySearchBoxContainer: FC<PropsWithChildren> = ({ children }) => (
  <Box
    sx={{
      position: 'sticky',
      top: 0,
      px: 2,
      zIndex: (theme) => theme.zIndex.modal,
    }}
  >
    {children}
  </Box>
)
